import { TThunkAction } from '../../types/redux';
import {
  EAlertType,
  IOpenAuthModalParameters,
} from '../../repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';

export { EAlertType };

export interface IRequestAuthenticationParameters extends Pick<
  IOpenAuthModalParameters,
  'alert' | 'source' | 'viewData'
> {
  onSuccess?(): TThunkAction;
  onCloseNoAuth?(): TThunkAction;
}

export const TOPIC_USER = 'user';
